/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Gallery_Desc_Clickup1Inputs */



/**
* | output |
* | --- |
* | "Sync tasks and docs from your workspaces." |
*
* @param {Spaces_Gallery_Desc_Clickup1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const spaces_gallery_desc_clickup1 = /** @type {((inputs?: Spaces_Gallery_Desc_Clickup1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Gallery_Desc_Clickup1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Aufgaben und Docs aus deinen Workspaces synchronisieren.")
	return /** @type {LocalizedString} */ ("Sync tasks and docs from your workspaces.")
});
export { spaces_gallery_desc_clickup1 as "spaces_gallery_desc_clickUp" }